import { app } from '../app';

app.factory('Groups', Groups);

/** @ngInject */
function Groups($resource) {
    return $resource('app/rest/company/:companyId/groups/:id', {
        companyId : '@companyId',
        id : "@id"
    }, {
        'getGroupsByType' : {
            method : 'GET',
            url : 'app/rest/company/:companyId/groups?type=:type',
            isArray : true,
            params : {
                companyId : '@companyId',
                type : '@type'
            }
        },
    });
}

app.factory('UserAccounts', UserAccounts);

/** @ngInject */
function UserAccounts($resource) {
    return $resource('app/rest/company/:companyId/useraccounts/:id', {
        companyId : '@companyId',
        id : "@id"
    }, {
        'getAccountsForGroup' : {
            method : 'GET',
            url : 'app/rest/company/:companyId/useraccounts?groupId=:groupId',
            isArray : true,
            params : {
                companyId : '@id',
                groupId : '@id'
            }
        },
        'getSharedEmailAccountsByUsername' : {
            method : 'GET',
            url : 'app/rest/company/:companyId/useraccounts/sharedemailaccountsbyusername?username=:username',
            isArray : true,
            params : {
                companyId : '@id',
                username : '@username'
            }
        },
        'getSharedEmailAccounts' : {
            method : 'GET',
            url : 'app/rest/company/:companyId/useraccounts/sharedemailaccounts?username=:username',
            isArray : true,
            params : {
                companyId : '@id'
            }
        },
        'getSharedEmailAccountType' : {
            method : 'GET',
            url : 'app/rest/company/:companyId/sharedemailccounts/accountType?username=:username',
            params : {
                companyId : '@id',
                username : '@username'
            }
        },
        'getGroupsOfAccount' : {
            method : 'GET',
            url : 'app/rest/company/:companyId/useraccounts/:id/groups',
            params : {
                companyId : '@id',
                id : '@id'
            },
            isArray : true
        },
        'assignUserToGroups' : {
            method : 'POST',
            url : 'app/rest/company/:companyId/useraccounts/:id/groups?addusers=true',
            params : {
                companyId : '@id',
                id : '@id'
            }
        },
        'createSharedUserAccount' : {
            method : 'POST',
            url : 'app/rest/company/:companyId/useraccounts/shared',
            params : {
                companyId : '@id'
            }
        },
        'deleteUserAccount' : {
            method : 'DELETE',
            url : 'app/rest/company/:companyId/useraccounts/:id',
            params : {
                companyId : '@companyId',
                id: "@id"
            }
        },
        'verify' : {
            method : 'POST',
            url : 'app/rest/company/:companyId/useraccounts/:id/verify',
            params : {
                companyId : '@id',
                id : '@id'
            }
        },
        'getBlockedUsers' : {
            method : 'GET',
            isArray : true,
            url : 'app/rest/company/:companyId/useraccounts?blocked=true',
            params : {
                companyId : '@id',
                id : '@id'
            }
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/services/groups-and-users.service.js